'use client';

import dynamic from 'next/dynamic';
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import {
  hasChatChannelAvaibleState,
  isLoadingChatChannelAvaibleState,
  widgetIsOpenState,
} from '@/components/Widget/atoms';
import { getBusinessHoursChannels } from '@/services/getBusinessHoursChannels';

import { Container } from './styles';

const Header = dynamic(
  () =>
    /* webpackChunkName: "Widget_Header" */
    import('./components/Header'),
);

const Steps = dynamic(
  () =>
    /* webpackChunkName: "Widget_Steps" */
    import('./components/Steps'),
);

const Card: React.FC = () => {
  const widgetIsOpen = useRecoilValue(widgetIsOpenState);
  const setHasChatChannelAvaible = useSetRecoilState(
    hasChatChannelAvaibleState,
  );
  const setIsLoadingChatChannelAvaibleState = useSetRecoilState(
    isLoadingChatChannelAvaibleState,
  );

  const checkIfHasChatChannelAvaible = useCallback(async () => {
    setIsLoadingChatChannelAvaibleState(true);
    const channels = await getBusinessHoursChannels();
    setHasChatChannelAvaible(channels.some(channel => channel === 'chat', []));
    setIsLoadingChatChannelAvaibleState(false);
  }, []);

  useEffect(() => {
    if (widgetIsOpen) {
      checkIfHasChatChannelAvaible();
    }
  }, [checkIfHasChatChannelAvaible, widgetIsOpen]);

  return (
    <Container widgetIsOpen={widgetIsOpen}>
      {widgetIsOpen && (
        <>
          <Header />
          <Steps />
        </>
      )}
    </Container>
  );
};

export default Card;
